import { Component, inject } from '@angular/core';
import { CardHeaderComponent } from 'common/card/header/card-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { ViewService } from 'api';
import { FormsModule } from '@angular/forms';
import { CardButtonsComponent } from 'common/card/buttons/card-buttons.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonDirective } from 'common/button/button.directive';

@Component({
  selector: 'comp-license-agreement',
  templateUrl: './license-agreement.component.html',
  styleUrls: ['./license-agreement.component.scss'],
  imports: [
    CardHeaderComponent,
    TranslateModule,
    FormsModule,
    CardButtonsComponent,
    ButtonDirective,
  ],
})
export class LicenseAgreementComponent {
  private readonly viewService = inject(ViewService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected async onSubmit() {
    await firstValueFrom(this.viewService.confirmLicenseAgreementApproval());
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') ?? '/dashboard';
    await this.router.navigateByUrl(returnUrl);
  }

  protected onDecline() {
    window.open('https://www.ul.com/', '_blank');
  }
}
